import PdfSVG from '@public/icons/pdf.svg';
import ZipSVG from '@public/icons/zip.svg';

export const getDocumentIconComponentByUrl = (url: string) => {
    const ext = url.split('.').pop();

    switch (ext) {
        case 'pdf':
            return PdfSVG as React.ElementType;
        case 'zip':
        case 'rar':
        case '7z':
        case 'tar':
        case 'gz':
        case 'tgz':
        case 'bz2':
        case 'xz':
        case 'zst':
        case 'iso':
            return ZipSVG as React.ElementType;
        default:
            return null;
    }
};
